import React from 'react';
import { connect } from 'react-redux';
import {
	Link,
} from 'react-router-dom';
import { pushEventToGTM } from '../../../helpers/trackerManager';
import CONSTANTS from '../../../constants';
import { CurrentStepSetAction } from '../../../actions/action';
import SummarySectionBlock from "../summarySectionBlock";
import Icon from '../../buttons/Icon';
import EditButton from '../../buttons/EditButton';

const mapStateToProps = state => state;
const mapDispatchToProps = { CurrentStepSetAction };


const PersonalInfosSummary = (props) => {
	const { personalInfos } = props.store;
	const civility = (personalInfos.civilityCode == "Common_Sir" ? CONSTANTS.LABELS.userinfos_mister : personalInfos.civilityCode == "Common_Madam" ? CONSTANTS.LABELS.userinfos_madam : CONSTANTS.LABELS.userinfos_neutral);
	const contactMethod = personalInfos.contactMode
	return (
		<SummarySectionBlock
			fold={props.fold}
			opened={props.opend}
			title={CONSTANTS.LABELS.summary_userinfos}>
			<div className="personalInfos-summary-block">
				<h3 tabIndex="0" className="block-title">{civility} {personalInfos.firstname} {personalInfos.name} </h3>
				<ul className="infos-list">
					<li className="list-item">
						<p tabIndex="0" className="info-block">
							<span className="info-block__title">{CONSTANTS.LABELS.summary_userinfos_email}</span>
							<Icon Name="email" />
							<span className="info-block__content">{personalInfos.mail}</span>
						</p>
					</li>
					<li className="list-item">
						<p tabIndex="0" className="info-block">
							<span className="info-block__title">{CONSTANTS.LABELS.summary_userinfos_tel}</span>
							<Icon Name="phone" />
							<span className="info-block__content">{personalInfos.phone}</span>
						</p>
					</li>

				</ul>
				<ul className="infos-list">
					<li className="list-item">
						<p tabIndex="0" className="info-block">
							{CONSTANTS.LABELS.summary_userinfos_contact_mode}  <span> {contactMethod} </span>
						</p>
					</li>

				</ul>

				{!props.store.isEditMode &&
					<Link to={CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE}
						onClick={(e) => {

							pushEventToGTM({
								pageName: 'summary',
								eventAction: 'Redirection::Internal::Modify',
								eventLabel: 'summary_modify_perso_data'
							});
							props.CurrentStepSetAction(5)
						}}>
						<EditButton />
					</Link>

				}

				{props.store.isEditMode && !props.expiredDate &&
					<Link to={CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE}
						onClick={(e) => {

							pushEventToGTM({
								pageName: 'summary',
								eventAction: 'Redirection::Internal::Modify',
								eventLabel: 'summary_modify_perso_data'
							});
							props.CurrentStepSetAction(5)
						}}>
						<EditButton />
					</Link>
				}
			</div>
		</SummarySectionBlock>

	)
}


export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfosSummary);
